import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DropdownOption } from '@maced/angular-components/lib/dropdown/dropdown.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html'
})
export class PageHeaderComponent implements OnInit {
  options: DropdownOption[] = [
    {
      id: 'option1',
      name: 'option1',
      label: '100%',
      url: '/pageHeader'
    },
    {
      id: 'option2',
      name: 'option2',
      label: '200%',
      url: '/pageHeader'
    },
    {
      id: 'option3',
      name: 'option3',
      label: '400%',
      url: '/pageHeader'
    }
  ];
  selectedOptions!: DropdownOption;
  callToAction = '/card';
  options1: DropdownOption[] = [
    {
      id: 'option11',
      name: 'option11',
      label: 'Unit2 Communication',
      url: '/pageHeader'
    },
    {
      id: 'option12',
      name: 'option12',
      label: 'Unit3 Communication',
      url: '/pageHeader'
    },
    {
      id: 'option13',
      name: 'option13',
      label: 'Unit4 Communication',
      url: '/pageHeader'
    }
  ];
  selectedOptions1!: DropdownOption;
  options2: DropdownOption[] = [
    {
      id: 'option21',
      name: 'option21',
      label: 'Lesson 1',
      url: '/pageHeader'
    },
    {
      id: 'option22',
      name: 'option22',
      label: 'Lesson 2',
      url: '/pageHeader'
    },
    {
      id: 'option23',
      name: 'option23',
      label: 'Lesson 3',
      url: '/pageHeader'
    }
  ];
  selectedOptions2!: DropdownOption;
  options3: DropdownOption[] = [
    {
      id: 'option31',
      name: 'option31',
      label: 'option 31',
      url: '/pageHeader'
    },
    {
      id: 'option32',
      name: 'option32',
      label: 'option 32',
      url: '/pageHeader'
    },
    {
      id: 'option33',
      name: 'option33',
      label: 'option 33',
      url: '/pageHeader'
    }
  ];
  selectedOptions3!: DropdownOption;
  tabItems: any[] = [];
  activeTab: string = "";
  show = true;
  sliderBtns: boolean = true;
  hasDropdowns = false as boolean;
  hasTabs = false as boolean;
  hasActions = false as boolean;
  hasLink = false as boolean;
  hasMetaData = false as boolean;
  hasActionDropdown = true as boolean;
  isBrowser: boolean;
  ariaLabels: any;
  padding = false;
  subTitle = 'Overline';
  title = 'Header';
  queryParams = { 'name': 'test' };
  backIconClass = 'icon-chevron-left';
  nextIconClass = 'icon-chevron-right';
  link1: { label: string, hyperLink: string, target: string } =
    { label: 'Link label', hyperLink: 'https://www.macmillaneducationeverywhere.com/terms-conditions/', target: '_blank' };
  private queryParamSubscription!: Subscription;
  constructor(private activatedRoute: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object) {
    this.tabItems = [
      {
        id: "nav1-tab",
        name: "Tab1",
        tabContentData: "Tab content data for Tab1",
        label: "Tab 1",
        targetUrl: "/pageHeader",
        tabContentId: "Tab1",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav2-tab",
        name: "Tab2",
        tabContentData: "Tab content data for Tab2",
        label: "Tab 2",
        targetUrl: "/pageHeader",
        tabContentId: "Tab2",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav3-tab",
        name: "Tab3",
        tabContentData: "Tab content data for Tab3",
        label: "Tab 3",
        targetUrl: "/pageHeader",
        tabContentId: "Tab3",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav4-tab",
        name: "Tab4",
        tabContentData: "Tab content data for Tab4",
        label: "Tab 4",
        targetUrl: "/pageHeader",
        tabContentId: "Tab4",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav5-tab",
        name: "Tab5",
        tabContentData: "Tab content data for Tab5",
        label: "Tab 5",
        targetUrl: "/pageHeader",
        tabContentId: "Tab5",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav6-tab",
        name: "Tab6",
        tabContentData: "Tab content data for Tab6",
        label: "Tab 6",
        targetUrl: "/pageHeader",
        tabContentId: "Tab6",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav7-tab",
        name: "Tab7",
        tabContentData: "Tab content data for Tab7",
        label: "Tab 7",
        targetUrl: "/pageHeader",
        tabContentId: "Tab7",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav8-tab",
        name: "Tab8",
        tabContentData: "Tab content data for Tab8",
        label: "Tab 8",
        targetUrl: "/pageHeader",
        tabContentId: "Tab8",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav9-tab",
        name: "Tab9",
        tabContentData: "Tab content data for Tab9",
        label: "Tab 9",
        targetUrl: "/pageHeader",
        tabContentId: "Tab9",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav10-tab",
        name: "Tab10",
        tabContentData: "Tab content data for Tab10",
        label: "Tab 10",
        targetUrl: "/pageHeader",
        tabContentId: "Tab10",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav11-tab",
        name: "Tab11",
        tabContentData: "Tab content data for Tab11",
        label: "Tab 11",
        targetUrl: "/pageHeader",
        tabContentId: "Tab11",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav12-tab",
        name: "Tab12",
        tabContentData: "Tab content data for Tab12",
        label: "Tab 12",
        targetUrl: "/pageHeader",
        tabContentId: "Tab12",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav13-tab",
        name: "Tab13",
        tabContentData: "Tab content data for Tab12",
        label: "Tab 13",
        targetUrl: "/pageHeader",
        tabContentId: "Tab13",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav14-tab",
        name: "Tab14",
        tabContentData: "Tab content data for Tab12",
        label: "Tab 14",
        targetUrl: "/pageHeader",
        tabContentId: "Tab14",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav15-tab",
        name: "Tab15",
        tabContentData: "Tab content data for Tab12",
        label: "Tab 15",
        targetUrl: "/pageHeader",
        tabContentId: "Tab15",
        isActive: false,
        isDisabled: false
      }
    ];
    this.isBrowser = isPlatformBrowser(platformId);
    this.ariaLabels = {
      previousButton: "Previous",
      nextButton: "Next"
    }
    this.activatedRoute.queryParams.subscribe(res => {
      if (res['tabId'] && res['activeTab']) {
        if (res['tabId'] == 'TabsContainer1') {
          this.activeTab = res['activeTab'];
        }
      }
      else {
        this.activeTab = "";
      }
    });
  }

  ngOnInit(): void {
    this.queryParamSubscription = this.activatedRoute.queryParams.subscribe(param => {
      if (param.dropdownId && param.dropdownId === 'dropdownId') {
        this.options.forEach((obj) => {
          if (obj.id === param.selectedDropdownOptionId) {
            obj.active = true;
            this.selectedOptions = obj;
          } else {
            obj.active = false;
          }
        });
      }
      if (param.dropdownId && param.dropdownId === 'dropdownId1') {
        this.options1.forEach((obj) => {
          if (obj.id === param.selectedDropdownOptionId) {
            obj.active = true;
            this.selectedOptions1 = obj;
          } else {
            obj.active = false;
          }
        });
      }
      if (param.dropdownId && param.dropdownId === 'dropdownId2') {
        this.options2.forEach((obj) => {
          if (obj.id === param.selectedDropdownOptionId) {
            obj.active = true;
            this.selectedOptions2 = obj;
          } else {
            obj.active = false;
          }
        });
      }
      if (param.dropdownId && param.dropdownId === 'dropdownId3') {
        this.options3.forEach((obj) => {
          if (obj.id === param.selectedDropdownOptionId) {
            obj.active = true;
            this.selectedOptions3 = obj;
          } else {
            obj.active = false;
          }
        });
      }
    })
  }
  ngOnDestroy(): void {
    if (this.queryParamSubscription) {
      this.queryParamSubscription.unsubscribe();
    }
  }

}
